<template>
  <v-main role="presentation" id="maintenance">
    <v-container class="text-center maintenance-content">
      <v-row class="widthForContent">
        <v-col cols="12" class="text-center mt-4 mb-4">
          <v-img height="82" width="82" :src="infoIcon" class="mx-auto" alt="info icon" />
        </v-col>
        <v-col cols="12" class="text-h1 mb-4 pb-4">
          {{ $t('L_maintenance_title') }}
        </v-col>
        <v-col cols="12" class="text-h4 font-weight-regular">
          {{ $t('L_maintenance_desc') }}
        </v-col>
        <v-col cols="12" class="text-h4 font-weight-regular mt-0 pt-0 mb-4 pb-4">
          {{ $t('L_maintenance_footer') }}
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapStores } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import infoIcon from '@/assets/info-icon.svg';

const componentOptions: ComponentOptions = {
  name: 'MaintenancePage',
  data: () => ({
    deviceType: null,
    infoIcon,
  }),
  computed: {
    ...mapStores(useGlobalStore, useCustomerStore),
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
#maintenance {
  background-color: #ffffff;
  height: 100%;
}

.maintenance-canvas {
  max-width: 100% !important;
  height: 100%;
}

.maintenance-content {
  max-width: 100% !important;
  height: 80%;

  @media only screen and (min-width: 760px) {
    max-width: 75% !important;
    height: 80%;
  }
}

.maintenance_title {
  font-size: 24px !important;
}

.maintenance_prompt {
  font-size: 18px !important;
}

#maintenance p {
  color: #333 !important;
}

#maintenance a.text-decoration-none {
  text-decoration: none !important;
}

a.underline-link {
  text-decoration: underline !important;
}

.pad-bottom {
  padding-bottom: 100px;
}

.info-img {
  height: 104px;
  width: 104px;
}

.btn_white {
  background-color: white !important;
}
</style>
